// extracted by mini-css-extract-plugin
export default {"chats":"Chats_chats__MMCJu","title":"Chats_title__2Eqzu","list":"Chats_list__9TUrU"};